/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { tenantsGetPortalUrl } from "../../funcs/tenantsGetPortalUrl.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  tenantId: z.string(),
  theme: operations.Theme$inboundSchema.optional(),
};

export const tool$tenantsGetPortalUrl: ToolDefinition<typeof args> = {
  name: "tenants-get-portal-url",
  description: `Get Portal Redirect URL

Returns a redirect URL containing a JWT to authenticate the user with the portal. Requires Admin API Key.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await tenantsGetPortalUrl(
      client,
      args.tenantId,
      args.theme,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
